export const GET_OFFICER_BY_USERNAME_QUERY = `
  query getOfficerByUsername($county: String!, $username: String!) {
    getOfficerByUsername(county: $county, username: $username) {
      __typename

      ...on OfficerData {
        id
        fullName
        firstName
        lastName
        email
        phone
      }
    }
  }
`;
export const GET_OFFICER_LOOKUP = `
  query getOfficerLookup($county: String!, $queryString: String!, $count: Int!, $after: String,$filters: OfficerFilters) {
    getOfficerLookup(county: $county, queryString: $queryString, count: $count, after: $after, filters: $filters) {
      __typename

      ... on OfficerLookupData {
        officers {
          id
          lastName
          fullName
          firstName
          email
          phone
          supervisor{
            code
            value
          }
          unit{
            code
            value
          }
        }
        count
      }
    }
  }
`;
export const GET_OFFICER_MODAL_FILTERS = `
  query getOfficerModalFilters($county: String!) {
    getSupervisors(county: $county) {
      __typename

      ... on SupervisorItems {
        count
        supervisors {
          code
          label
          value
        }
      }
    }

    getUnitLocations(county: $county) {
      __typename

      ... on UnitLocationsItems {
        count
        units {
          code
          label
          value
        }
      }
    }

    getPersonnelFeatures(county: $county) {
      __typename

      ... on PersonnelFeatures {
          useUnits{
            enabled
          }
      }
    }
  }
`;
